var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy-now-login"},[_c('login-form',{attrs:{"loading":_vm.loading,"login-error":_vm.loginError},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }